
import Vue from 'vue';
import { BButton, BSpinner } from 'bootstrap-vue';

export default Vue.extend({
	components: {
		BButton,
		BSpinner
	},
	inheritAttrs: false,
	props: {
		enableSaveState: {
			type: Boolean,
			required: true,
			default: false
		}
	},
	computed: {},
	methods: {}
});
